import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";import {useNavigate} from "react-router-dom";
import {UserPermission} from "../../utils/utils";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import {isUserAdmin} from "../../utils/requestUtils";

const apiUrl = Config.apiUrl;
const PaymentMethodMercadoPagoList = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [paymentMethodsMercadoPago, setPaymentMethodsMercadoPago] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const [userAdmin, setUserAdmin] = useState(undefined);


    useEffect(() => {
        isUserAdmin().then(userAdmin => setUserAdmin(userAdmin));
    }, []);

    async function makeQuery(query) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethodsMercadoPago/query=' + (query && query !== '' ? (query) : '');
            setLoading(true);
            const response = await makeRequest(url, 'GET');
            setPaymentMethodsMercadoPago(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []);

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };


    async function removePaymentMethodMercadoPago(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/paymentMethodsMercadoPago/' + id;
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    if (userAdmin === undefined && loadingPermissions) {
        return <Loading></Loading>;
    }
    if (userAdmin !== undefined && !userAdmin) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Consulta de Formas de Pagamento Mercado Pago</div>
                <button className={"new-button"} onClick={() => navigate('/admin/paymentmethodmercadopago')}>Novo</button>
            </div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
            </div>
            <table style={{width: '540px'}}>
                <colgroup>
                    <col style={{width: '300px'}}/>
                    <col style={{width: '240px'}}/>
                    <col style={{width: 'auto'}}/>
                </colgroup>

                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Código Mercado Pago</th>
                    <th/>
                </tr>
                </thead>

                <tbody style={{overflowY: 'auto'}}>
                {paymentMethodsMercadoPago.map((paymentMethodMercadoPago, index) => (
                    <tr key={index}>
                        <td>{paymentMethodMercadoPago.name}</td>
                        <td>{paymentMethodMercadoPago.codeMercadoPago}</td>
                        <td>
                            <div style={{display: 'flex'}}>
                                <button onClick={async () => {
                                    await navigate('/admin/paymentmethodmercadopago?id=' + paymentMethodMercadoPago.id);
                                }}>Editar
                                </button>
                                <button
                                    className="remove-button"
                                    onClick={async () => {
                                        if (window.confirm('Deseja realmente excluir?')) {
                                            await removePaymentMethodMercadoPago(paymentMethodMercadoPago.id);
                                        }
                                    }}
                                >
                                    Excluir
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
                {paymentMethodsMercadoPago.length === 0 && <tfoot>Nenhum item encontrado.</tfoot>}
                </tbody>
            </table>
        </>
    );
};

export default PaymentMethodMercadoPagoList; 